import React from "react";
import SectionHeading from "../common/SectionHeading";

const ProgressTrackerSection = () => {
	const steps = [
		{
			title: "Pickup & Documentation",
			description:
				"We collect your shipment and ensure all documents are accurately prepared for seamless processing.",
		},
		{
			title: "Customs Clearance & Handling",
			description:
				"Our experts handle customs, inspections, and duties, ensuring full compliance with local regulations.",
		},
		{
			title: "Final Delivery",
			description: "customs clearance for smooth delivery.",
		},
	];

	return (
		<section className="md:py-20 py-10 px-5 bg-white">
			<div className="max-w-7xl mx-auto px-4">
				<div className="mb-10">
					<SectionHeading
						subtitle="Workflow"
						title="Our process to deliver your package"
					/>
				</div>

				{/* Grid Container */}
				<div className="grid grid-cols-1 md:grid-cols-3 border border-gray-100 rounded-2xl overflow-hidden shadow-sm">
					{steps.map((step, index) => (
						<div
							key={index}
							className={`relative p-8 transition-all duration-300 group ha:bg-brand-500 ha:z-20
                ${(index + 1) % 2 === 0 ? "bg-gray-50" : "bg-white"}                 
              `}
						>
							{/* Step Number Badge */}
							<div className="flex items-center justify-between mb-6">
								<div
									className={`Ethnocentric text-2xl transition-colors duration-300 gh:text-white 
                    ${(index + 1) % 2 === 0 ? "text-brand-500" : "text-gray-300"}
                  `}
								>
									0{index + 1}
								</div>

								{/* Small Icon or Circle */}
								<div className="w-2 h-2 rounded-full bg-brand-500 gh:bg-white animate-pulse"></div>
							</div>

							<div className="relative z-10">
								<h5 className="font-bold text-gray-900 uppercase tracking-tight mb-3 gh:text-white transition-colors">
									{step.title}
								</h5>

								<p className="text-sm text-gray-500 leading-relaxed gh:text-white transition-colors">
									{step.description}
								</p>
							</div>

							{/* Background Number Watermark */}
							<span className="absolute bottom-2 right-4 Ethnocentric text-6xl opacity-[0.02] gh:opacity-10 gh:text-white transition-all pointer-events-none">
								{index + 1}
							</span>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default ProgressTrackerSection;
